import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing development configuration and profile

/**
 * Class representing the history movement view.
 * @extends JetView
 */
export default class tableHistoryMovementView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // Unique identifier for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo'), // Localized column header
                                    editor: 'combo', // Editor type for the column
                                    options: [
                                        // Options for the combo editor
                                        { id: '1', value: _('Click Banner') },
                                        { id: '2', value: _('Links') },
                                        { id: '3', value: _('Registros') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId', // Column ID
                                    header: _('ID Externo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreationDate', // Column ID
                                    header: _('Fecha de creación'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting function
                                },
                                {
                                    id: 'Value', // Column ID
                                    header: _('Valor'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting function
                                    exportType: 'number', // Export type
                                },
                            ],
                            on: {
                                // Event handlers for the DataTable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with OverlayBox functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Load ahead option
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        var url = devConfig.geturlApi() + 'Client/GetReportMarketing?'; // API URL for fetching data
        var filter = ''; // Filter string for API requests
        const _ = this.app.getService('locale')._; // Localization service
        var flag = false; // Flag for export operation

        // Event listener for filtering data
        this.on(this.app, 'filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date; // Add date to filter string
                                string1 = string1 + '&dateTo=' + date; // Add date to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for exporting filtered data
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set flag for export operation
            var firstfirst; // Variable to hold the first record index
            if (filterData.first == 0) {
                // Adjust first index if it's zero
                firstfirst = filterData.first + 1;
            } else {
                firstfirst = filterData.first; // Use the provided first index
            }
            grid.load(
                // Load data for export
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter,
            );
            grid.attachEvent(
                // Attach event for after load
                'onAfterLoad',
                function () {
                    if (flag) {
                        // Check if exporting
                        var size = grid.getPager().config.size; // Get page size
                        var page = grid.getPage(); // Get current page
                        var first = size * page; // Calculate first record index
                        var last = first + size - 1; // Calculate last record index
                        if ($$('Export').getValue() == '1') {
                            // Check if exporting to Excel
                            for (var j = 0; j < grid.config.columns.length; j++) {
                                if (grid.config.columns[j].exportType) {
                                    // Check for export type
                                    delete grid.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                // Trigger export event
                                {
                                    NameReport:
                                        _('Reporte de marketing') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(),
                                    TypeReport: 'Excel', // Set report type
                                },
                            ]);
                            webix.toExcel(grid, {
                                // Export to Excel
                                filter: function (obj) {
                                    // Filter function for export
                                    return grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last;
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Reporte de marketing'),
                                ignore: { detailTittle: true }, // Ignore detail title in export
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                // Check if exporting to PDF
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            _('Reporte de marketing') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(),
                                        TypeReport: 'PDF', // Set report type
                                    },
                                ]);
                                webix.toPDF(grid, {
                                    // Export to PDF
                                    filter: function (obj) {
                                        // Filter function for export
                                        return grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last;
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de marketing'),
                                    autowidth: true, // Enable auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset flag after export
                        $$('Export').setValue(''); // Reset export selection
                    }
                }.bind(this), // Bind the context to the current instance
            );
        });
    }
}

// FILE DOCUMENTED
